<template>
  <Modal
    id="RepairLogEdit"
    width="60%"
    :open="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
  >
    <Row align="middle" justify="center">
      <Col span="18" >
        <Row>
          <Col span="24">
            <Form
              ref="repairLogForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                  <Col span="10">
                    <FormItem :label="$t('repairLog.field.id_car')" name="idCar">
                        <!--关联表的下拉选择-->
                        <Select
                                v-model:value="form.idCar"
                                :placeholder="$t('repairLog.validate.required.id_car')"
                                :dropdownStyle="{ zIndex: 9999999950 }"
                        >
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['carList']" :value="item['idCar']">{{ item['model'] }}</SelectOption>
                        </Select>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('repairLog.field.amount')" name="amount">
                                            <InputNumber
                                                    v-model:value="form.amount"
                                                    :placeholder="$t('repairLog.validate.required.amount')"
                                                    :step="0.01"
                                            />
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('repairLog.field.repair_date')" name="repairDate">
                      <DatePicker valueFormat="YYYY-MM-DD" v-model:value="form.repairDate" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('repairLog.field.remark')" name="remark">
                                            <Input :placeholder="$t('repairLog.validate.required.remark')"
                                                   v-model:value="form.remark">
                                            </Input>
                  </FormItem>
                  </Col>
                  <!-- <Col span="10">
                    <FormItem :label="$t('repairLog.field.tenant_key')" name="tenantKey">
                                            <Input :placeholder="$t('repairLog.validate.required.tenant_key')"
                                                   v-model:value="form.tenantKey">
                                            </Input>
                  </FormItem>
                  </Col> -->
                <!--判断是否有子表，如果有则直接加入子表管理逻辑-->
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
  Space,
  Card,
  Table,
  Popconfirm,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { RepairLogAdd, RepairLogEdit } from "@/api/repairLog";
import { CarListAll } from "@/api/car"

export default {
  name: "RepairLogEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    MinusCircleOutlined,
    ExclamationCircleOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    Descriptions,
    DescriptionsItem,
    Space,
    Card,
    Table,
    Popconfirm,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idRepLog : "",
        idCar : "",
        amount : "",
        repairDate : "",
        remark : "",
        tenantKey : "",
      },
      fileList: {
      },
      selectList: {
        carList: [],
      },
      validateRules: {
        idRepLog: [
          {
            required: true,
            message: this.$t("repairLog.validate.required.id_rep_log"),
            trigger: "change",
            type: "number",
          },
        ],
        idCar: [
          {
            required: true,
            message: this.$t("repairLog.validate.required.id_car"),
            trigger: "change",
            type: "number",
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("repairLog.validate.required.amount"),
            trigger: "change",
            type: "number",
          },
        ],
        repairDate: [
          {
            required: true,
            message: this.$t("repairLog.validate.required.repair_date"),
            trigger: "change",
          },
        ],
        remark: [
          {
            required: true,
            message: this.$t("repairLog.validate.required.remark"),
            trigger: "change",
          },
        ],
        tenantKey: [
          {
            required: true,
            message: this.$t("repairLog.validate.required.tenant_key"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  watch: {
      "visible": {
          deep: true,
          handler: function (newValue, oldValue) {
              if (!newValue) {
                  this.$emit("updateList");
              }
          }
      }
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.getCarList();
      this.visible = true;
    },
    async editShow(obj) {
      this._resetData();
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.getCarList();
      this.visible = true;
    },
    submit() {
      this.$refs["repairLogForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new RepairLogAdd();
              break;
            case "edit":
              console.log("edit");
              api = new RepairLogEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 == parseInt(response.data.code)) {
              message.success(this.$t("succeedMsg.0"));
              this.$emit("updateList",response.data.data);
              this.visible = false;
            } else {
              if(response.data.code !== undefined){message.error(this.$t("errorMsg." + response.data.code));}
            }
          });
        })
        .catch(() => {
        });
    },
    getCarList() {
      const api = new CarListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
            this.selectList.carList = response.data.data;
        } else {
            if(response.data.code !== undefined){message.error(this.$t("errorMsg." + response.data.code));}
        }
      });
    },
    // reset data
    _resetData() {
      this.form = {
        idRepLog : "",
        idCar : "",
        amount : "",
        repairDate : "",
        remark : "",
        tenantKey : "",
      };
    },
  },
};
</script>

<style lang="less">
</style>
